import { decodeGetOptions, encodeAssertion, supportsWebAuthn, wasCancelled } from '@clevver/helpers/webauthn'

const csrfToken = (): string =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''

const post = async (url: string, body: object = {}) => {
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-Token': csrfToken() },
    body: JSON.stringify(body),
  })

  const data = await response.json()

  if (!response.ok) { throw new Error(data.error || 'Something went wrong.') }

  return data
}

const signIn = async (button: HTMLButtonElement, optionsUrl: string, createUrl: string) => {
  button.disabled = true

  try {
    const options = await post(optionsUrl)
    const credential = await navigator.credentials.get({ publicKey: decodeGetOptions(options) }) as PublicKeyCredential | null

    if (!credential) { return }

    const { redirect_to } = await post(createUrl, { credential: encodeAssertion(credential) })

    window.location.href = redirect_to
  } catch (error) {
    if (!wasCancelled(error)) { alert((error as Error).message) }
  } finally {
    button.disabled = false
  }
}

const button = document.getElementById('passkey-login') as HTMLButtonElement | null

if (button && supportsWebAuthn()) {
  button.classList.remove('auth__section--hidden')
  button.addEventListener('click', () => signIn(button, button.dataset.optionsUrl!, button.dataset.createUrl!))
}
